export default __webpack_public_path__ + "static/media/TraverseLogo2019Colored.62640d3b.png";